import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsGodrej } from "../../../../data/projects/Godrej/data";
import Main_Footer from "../../../../components/footer/IndiaFooter/Main_Footer";

export const Skyline = () => {
  const {
    godrejskyline: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar,
    },
  } = projectsGodrej;

  if (
    !bannerdata ||
    !overview ||
    !sitevisit ||
    !pricing ||
    !floor_plan ||
    !highlights ||
    !location ||
    !gallery ||
    !faq ||
    !similar
  ) {
    return <div>Loading...</div>; // or an error page, depending on your needs
  }

  return (
    <>
      <Helmet>
        <title>
          Godrej Skyline Mundhwa Pune | Luxury 3 & 4 BHK Apartments Near
          Koregaon Park
        </title>
        <meta
          name="description"
          content="Godrej Skyline in Mundhwa, Pune – premium 3 & 4 BHK apartments with stunning panoramic views, world-class amenities, and excellent connectivity. Starting at ₹3.07 Cr, possession by July 2029. "
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://propertystation.in/godrej-skyline-mundhwa-pune"
        />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
        <Main_Footer/>
      </div>
    </>
  );
};
